export const decisionTypes = {
  link: 'link',
  discard: 'discard',
}
